export const FETCH_VEHICLES =  "FETCH_VEHICLES"
export const FETCH_TRAILERS =  "FETCH_TRAILERS"
export const FETCH_ACTIVE_VEHICLES =  "FETCH_ACTIVE_VEHICLES"
export const FETCH_ACTIVE_TRAILERS =  "FETCH_ACTIVE_TRAILERS"
export const FETCH_INACTIVE_VEHICLES =  "FETCH_ACTIVE_VEHICLES"
export const FETCH_INACTIVE_TRAILERS =  "FETCH_ACTIVE_TRAILERS"

